import styled from 'styled-components';
import CurvedLine from '../assets/svg/CurvedLine2';
// import FeatureImage from '../assets/images/howToSection/featureImage.png';
import AddIcon from '../assets/svg/AddIcon';
import MinusIcon from '../assets/svg/MinusIcon';
import OutlinedTick from '../assets/svg/OutlinedTick';
import HeadingOutline1 from '../assets/svg/HeadingOutline1';
import ButtonArrowIcon from '../../../assets/svg/ButtonArrowIcon';
import ActionButton from '../../../components/ActionButton';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { PUBLIC_IMAGES_REPO } from '../../../../../utils/Constants';

const FeatureImage = `${PUBLIC_IMAGES_REPO}/featureImage.png`;

const Wrapper = styled.section`
position: relative;
display: flex;
flex-direction: column;
align-items: center;

.curved-line{
  position: absolute;
  top: -8%;
  right: 0;
  bottom: 40%;
  left: 10%;

  svg{
    height: 100%;
    width: 100%;
  }
}

.host-your-website{
  position: absolute;
  padding: 6px 12px;
  border-radius: 3px;
  background: var(--BG-Color, #F2F2F2);
  color: transparent;
  left: 5%;
  top: 6%;
  border: none;
  width: 9.375rem;
  color: var(--primary-primary-600-f, #62AA48);
  transform: rotate(4deg);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.mobile-heading{
  display: none;
}

.container-1{
  width: 100%;
  background: var(--BG-Color, #F2F2F2);
  
  .container {
    position: relative;
    max-width: 1440px;
    display: flex;
    justify-content: start;
    align-items: center;
    width: 100%;
    padding: 9.375rem 3.75rem 9.375rem 6.25rem;
  }

  h2{
    color: var(--font-color-font-1, #1B131F);
    font-family: Instrument Sans;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: 88px;
    width: 75%;
  }

  .desktop-heading {
    position: relative;
  
    .outline {
      position: absolute;
      left: -20px;
      top: -5px;
  
      svg{
        width: 80%;
      }
    }
  }

  .mobile-heading{
    display: none;
  }

  .label{
    display: flex;
    width: 144px;
    transform: rotate(4.936deg);
    padding: 6px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    position: absolute;
    right: 596.436px;
    top: 311px;
    border: none;
    border-radius: 3px;
    background: var(--primary-primary-900, #27441D);
    color: var(--white-shades-white-100, #FFF);
    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  ul{
    list-style: none;
    padding: 0;
    margin-top: 32px;

    li{
      color: var(--font-color-font-1, #1B131F);
      font-family: Instrument Sans;
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 32px;
      padding: 8px 0;

      .li-item{
        display: flex;
        align-items: center;
        gap: 10px;
        cursor: pointer;

        .svg-container{
          width: 5%;
          cursor: pointer;
        }

        p{
          color: var(--font-color-font-1, #1B131F);
          font-family: Instrument Sans;
          font-size: 24px;
          font-style: normal;
          font-weight: 500;
          line-height: 32px;
        }
      }

      .sub-text{
        height: 32px;
        margin-top: 10px;
        margin-left: 16px;
        border-left: 1px solid var(--primary-primary-600-f, #62AA48);;
        padding-left: 25px;
        display: flex;
        align-items: center;

        p{

          color: var(--font-color-font-1, #1B131F);
          font-family: Instrument Sans;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
      }

      :not(:last-child) {
        margin-bottom: 24px;
      }
      
      p{
        margin: 0;
      }
    }
  }
}

.container-2{
  width: 100%;
  background: var(--primary-primary-400, #8DD473);
  
  .container {
    max-width: 1440px;
    position: relative;
    padding: 6.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  h2{
    color: var(--font-color-font-4, #FFF);
    text-align: center;

    font-family: Instrument Sans;
    font-size: 64px;
    font-style: normal;
    font-weight: 700;
    line-height: 88px;
    padding: 0 5rem;
  }

  .list-item{
    display: flex;
    padding: 24px;
    align-items: center;
    gap: 16px;
    align-self: stretch;border-radius: 116px;
    border-bottom: 1px solid var(--primary-primary-600-f, #62AA48);
    background: var(--primary-primary-600-f, #62AA48);
    width: 49%;

    .svg-container{
      width: 10%;
      min-width: 50px;
    }

    p{
      color: var(--primary-primary-50, #F0FFEB);
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
    }
  }
}

.action-button{
  margin: 48px 0;
}

@media screen and (max-width: 1024px){
.host-your-website{
  position: absolute;
  padding: 6px 12px;
  border-radius: 3px;
  background: var(--BG-Color, #F2F2F2);
  color: transparent;
  left: 5%;
  top: 6%;
  border: none;
  width: 9.375rem;
  color: var(--primary-primary-600-f, #62AA48);
  transform: rotate(4deg);
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.container-1{
  
  .container {
    position: relative;
    max-width: 1440px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 6.375rem 3.75rem;
  }

  .container > .list-holder {
    width: 100%;
  }

  img{
    width: 50%;
  }

  h2{
    font-size: 45px;
    line-height: 58px;
    width: 75%;
  }

  .desktop-heading {
    .outline {
      top: -3px;
  
      svg{
        width: 60%;
      }
    }
  }

  .label{
    right: 40%;
    top: 35%;
  }

  ul{
    margin-top: 1rem;

    li{
      font-size: 18px;
      line-height: 28px;
      padding: 4px 0;

      .li-item{
        p{
          font-size: 18px;
          line-height: 28px;
        }
        .svg-container{
          width: 30px;
        }
      }

      :not(:last-child) {
        margin-bottom: 1rem;
      }
    }
  }
  
  .sub-text{
    min-height: 24px;
    height: auto !important;
  }
}

.container-2{
  width: 100%;
  background: var(--primary-primary-400, #8DD473);
  
  .container {
    padding: 6.25rem 3.75rem;
  }

  h2{
    font-size: 45px;
    line-height: 58px;
    padding: 0 2.5rem;
  }

  .list-item{
    padding: 1rem;
    gap: 0.75rem;
    width: 48%;

    .svg-container{
      width: 15%;

    }

    p{
      font-size: 20px;
      font-weight: 600;
      line-height: 32px;
    }
  }
}

}

@media screen and (max-width: 768px) {

  .curved-line{ 
    svg{
      height: 40%;
      width: 60%;
    }
  }

  .host-your-website{
    position: absolute;
    padding: 4px 8px;
    left: 8%;
    top: 4%;
    width: 7rem;
    transform: rotate(4deg);
    font-size: 12px;
    line-height: 16px;
  }

  .action-button{
    margin: 32px 0;
    padding: 12px 16px;
    font-size: 16px;
    line-height: 20px;
  }

  .container-1{
    img{
      width: 100%;
    }
    .container{
      margin-top: 32px;
      flex-wrap: wrap-reverse;
      padding: 2rem;
    }

    .desktop-heading {
      display: none;
    }
  
    .mobile-heading{
      display: block;

      .outline {
        position: absolute;
        left: 25px;
        top: 30px;
    
        svg{
          width: 40%;
        }
      }
    }

    h2{
      font-size: 32px;
      line-height: 40px;
      width: 100%;
    }
  
    ul{
      list-style: none;
      padding: 0;
      margin-top: 24px;
  
      li{
        font-size: 18px;
        line-height: 26px;

        .li-item{
          p{
            font-size: 18px;
            line-height: 26px;
          }

          .svg-container{
            // width: 10%;
            width: 30px;
          }

        }
        
        .sub-text{
            // height: 24px;
            min-height: 24px;
            height: auto;
  
            p{
              font-size: 16px;
              line-height: 24px;
            }
        }

        :not(:last-child) {
          margin-bottom: 16px;
        }
        
      }
    }

    .label{
      right: unset;
      top: 16%;
      left: 7px;
    }
  }

  .container-2{
    background: var(--primary-primary-400, #8DD473);
    
    .container {
      position: relative;
      padding: 4.25rem 1.25rem 2rem 1.25rem;
    }
  
    h2{
      font-size: 32px;
      line-height: 40px;
      padding: 0 2rem;
    }
  
    .list-item{
      display: flex;
      padding: 8px;
      align-items: center;
      gap: 16px;
      align-self: stretch;border-radius: 116px;
      border-bottom: 1px solid var(--primary-primary-600-f, #62AA48);
      background: var(--primary-primary-600-f, #62AA48);
      width: 100%;

      .svg-container{
        width: 5%;
      }

      svg{
        height: 32px;
        width: 32px;
      }
  
      p{
        color: var(--primary-primary-50, #F0FFEB);
        font-size: 16px;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }

}

@media screen and (max-width: 768px) {

  .container-2{
    .list-item{}
      .svg-container{
        // width: 10%;
        width: 30px;
      }
    }
  }
}
`;
const list = [
  'Easily update prices',
  'Get started for Free',
  'Simple to Build',
  'No setup Cost',
  'Simple to Update',
  'Boost your visibility with a search engine optimized website',
];

const steps = [
  {
    label: 'Create an Account',
    subtext: 'No credit card required',
  },
  {
    label: 'Choose a Website theme',
    subtext:
      'Compare and select from our highly customizable options.  Add and remove pages and sections with the click of a button',
  },
  {
    label: 'Customize images and content to make it yours',
    subtext:
      'Choose from our huge selection of stock images to make your website unique and beautiful',
  },
  {
    label: 'Add Products or Choose from the Catalog',
    subtext:
      'In addition to adding your own products, you can choose Products from our Catalog to expand your offerings',
  },
  {
    label: 'Publish your site',
    subtext:
      'When you are ready, easily publish your site to make it available to the world!',
  },
];

const HowToCreate = () => {
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <Wrapper>
      <div className="curved-line">
        <CurvedLine />
      </div>

      <div className="container-1">
        <div className="container">
          <div className="list-holder">
            <h2 className="desktop-heading">
              <span>
                How to{' '}
                <span className="outline">
                  <HeadingOutline1 />
                </span>
              </span>{' '}
              Create a free Floral website.
            </h2>
            <ul>
              {steps.map((item, index) => (
                <li key={index}>
                  <div
                    className="li-item"
                    onClick={() =>
                      setOpenIndex((state) => (state === index ? -1 : index))
                    }
                  >
                    <div className="svg-container">
                      {openIndex === index ? <MinusIcon /> : <AddIcon />}
                    </div>
                    <p>{item.label}</p>
                  </div>
                  {item.subtext && openIndex === index && (
                    <div className="sub-text">
                      <p>{item.subtext}</p>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          <img
            style={{ minHeight: 230 }}
            loading="lazy"
            src={FeatureImage}
            alt="Steps to build Flower shop online store using Best website platform for florists BoostFloral"
          />
          <h2 className="mobile-heading">
            <span>
              How to{' '}
              <span className="outline">
                <HeadingOutline1 />
              </span>
            </span>{' '}
            Create a free Floral website.
          </h2>
          <div className="label">Easy to create</div>
        </div>
      </div>

      <div className="container-2 d-flex flex-column align-items-center">
        <div className="container">
          <button className="host-your-website">Host your website</button>
          <h2>Why BoostFloral Website Hosting is the best choice for you</h2>
          <Link className="text-decoration-none" to="/our-process">
            <ActionButton className="action-button">
              Get Started <ButtonArrowIcon />
            </ActionButton>
          </Link>
          <div className="d-flex flex-wrap gap-4 justify-content-between">
            {list.map((item, index) => (
              <div key={index} className="list-item">
                <div className="svg-container">
                  <OutlinedTick />
                </div>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default HowToCreate;
